import { render, staticRenderFns } from "./training.copy.vue?vue&type=template&id=4f972064&scoped=true&"
import script from "./training.copy.vue?vue&type=script&lang=js&"
export * from "./training.copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f972064",
  null
  
)

export default component.exports